import { PhoneNumberUtil } from 'google-libphonenumber'
import { toLocale } from '$func/text'

// TODO review
export const normalizePhone = (phone: string) => {
  let trimmedPhone = phone.trim()
  if (!trimmedPhone) return ''

  if (trimmedPhone.match(/^[^0+]/)) trimmedPhone = `0${trimmedPhone}`

  const justStartingPlus =
    trimmedPhone[0] + trimmedPhone.substring(1).replace(/\++/g, '')
  const normalized = justStartingPlus
    .replace(/[^\d+]+/g, '')
    .replace(/^00/, '+')
    .replace(/^0/, '+98')

  return normalized.startsWith('+') ? normalized : ''
}

export const addCountryCodeToNumber = (phone: string, code: string) =>
  `+${code}${code === '98' && phone.startsWith('0') ? phone.slice(1) : phone}`

export const toHumanReadablePhone = (phone?: string, locale = true) => {
  if (!phone) return ''

  const formattedPhone = phone.replace('+98', '0')
  return locale ? toLocale(formattedPhone || '', false) : formattedPhone
}

const phoneUtil = PhoneNumberUtil.getInstance()

/*
  google-libphonenumber ships a per-operator prefix list for Iran that lags
  behind the ranges CRA keeps handing out (Aptel 0999, Shatel Mobile 0998,
  0906/0907/0909, 094x, 095x ...), so it rejects perfectly valid SIM cards and
  users cannot even reach the OTP step. Any +989xxxxxxxxx is a real Iranian
  mobile, and that is the only shape the backend asks for, so short-circuit it
  here and leave the library to the countries it does know.
*/
const IRAN_MOBILE_PATTERN = /^\+989\d{9}$/

export const isPhoneValidByLib = (phone: string) => {
  if (phone.startsWith('+98')) return IRAN_MOBILE_PATTERN.test(phone)

  try {
    return phoneUtil.isValidNumber(phoneUtil.parseAndKeepRawInput(phone))
  } catch (error) {
    return false
  }
}

export const isMobilePhone = (phone: string) => {
  if (phone.startsWith('+98')) return IRAN_MOBILE_PATTERN.test(phone)

  try {
    return phoneUtil.getNumberType(phoneUtil.parseAndKeepRawInput(phone)) === 1
  } catch (error) {
    return false
  }
}
